export enum SharedItemPriority {
    Low,
    Normal,
    High
}
